export const UPDATE_MARGIN_FIELDS = 'UPDATE_MARGIN_FIELDS';

interface UpdateMarginFields {
  type: typeof UPDATE_MARGIN_FIELDS;
  payload: Partial<IMarginFields>;
}

export type MarginActionTypes = UpdateMarginFields;